module.exports = __webpack_public_path__ + "img/Treat_item_down_arrow.f9839ba1.svg";